



























import { Component, Vue } from "vue-property-decorator";
import Loading from "@/shared/components/loading.vue";
import Modal from "@/shared/components/modal.vue";
import SelectConsultor from "@/shared/components/select-consultor.vue";
import { Parceiro, ParceirosService } from "@/services/parceiros.service";
import { required } from "@/shared/validators";

@Component({
  components: {
    Loading,
    Modal,
    SelectConsultor,
  },
})
export default class Manter extends Vue {
  parceiroSelecionado: Parceiro | null = null;
  loading = false;
  rules = {
    pix: [required()],
  };
  async associar() {
    const modal = this.$refs.modal as Modal;
    const form = this.$refs.form as any;

    if (form.validate()) {
      this.loading = true;
      if (this.parceiroSelecionado) {
        await ParceirosService.associarParceiro(
          this.parceiroSelecionado
        ).finally(() => {
          this.loading = false;
        });
      }
      this.loading = false;
      return modal.close(true);
    }
  }

  fechar() {
    const modal = this.$refs.modal as Modal;
    modal.close(false);
  }
  public async associarParceiro() {
    const modal = this.$refs.modal as Modal;

    this.parceiroSelecionado = null;

    return modal.open();
  }
}
